import {
  axisPointerStyle,
  tooltipPosition,
  tooltipStyle,
  tooltipTrigger,
} from './chart-tooltip'

export interface ChartStyles {
  legend: {
    orient: string
    top: number
    left: string
    padding: number[]
    textStyle: {
      fontSize: number
      color: string
    }
  }
  grid: {
    top: number
    bottom: number
    left: number
    right: number
  }
  tooltip: {
    trigger: string
    axisPointer: any
    position: any
    backgroundColor: string
    borderColor: string
    borderWidth: number
    extraCssText: string
    textStyle: any
  }
  seriesDefaults: {
    showSymbol: boolean
    symbol: string
    symbolSize: number
    smooth: boolean
    smoothMonotone: string
    lineStyle: {
      width: number
      shadowBlur: number
      shadowOffsetY: number
    }
  }
}

export const baseChartStyles: ChartStyles = {
  legend: {
    orient: 'horizontal',
    top: 25,
    left: 'center',
    padding: [0, 10, 10, 10],
    textStyle: {
      fontSize: 9,
      color: '#333',
    },
  },
  grid: {
    top: 60,
    bottom: 30,
    left: 80,
    right: 80,
  },
  tooltip: {
    trigger: tooltipTrigger,
    axisPointer: axisPointerStyle,
    position: tooltipPosition,
    backgroundColor: tooltipStyle.backgroundColor,
    borderColor: tooltipStyle.borderColor,
    borderWidth: tooltipStyle.borderWidth,
    extraCssText: tooltipStyle.extraCssText,
    textStyle: tooltipStyle.textStyle,
  },
  seriesDefaults: {
    showSymbol: false,
    symbol: 'none',
    symbolSize: 0,
    smooth: true,
    smoothMonotone: 'x',
    lineStyle: {
      width: 3,
      shadowBlur: 10,
      shadowOffsetY: 2,
    },
  },
}

export const createYAxisConfig = (
  leftAxis: { name: string; color: string },
  rightAxis?: { name: string; color: string },
) => {
  const yAxis = [
    {
      type: 'value',
      name: leftAxis.name,
      position: 'left',
      axisLine: {
        show: true,
        lineStyle: {
          color: leftAxis.color,
        },
      },
      axisLabel: {
        color: leftAxis.color,
        margin: 8,
      },
      nameTextStyle: {
        color: leftAxis.color,
        padding: [0, 0, 0, 0],
      },
      splitLine: {
        show: true,
        lineStyle: {
          color: '#e0e0e0',
          opacity: 0.3,
        },
      },
    },
  ]

  if (rightAxis) {
    yAxis.push({
      type: 'value',
      name: rightAxis.name,
      position: 'right',
      axisLine: {
        show: true,
        lineStyle: {
          color: rightAxis.color,
        },
      },
      axisLabel: {
        color: rightAxis.color,
        margin: 8,
      },
      nameTextStyle: {
        color: rightAxis.color,
        padding: [0, 0, 0, 0],
      },
      splitLine: {
        show: false,
        lineStyle: {
          color: '#e0e0e0',
          opacity: 0.3,
        },
      },
    })
  }

  return yAxis
}

export const applySeriesStyles = (
  series: any[],
  baseStyles: ChartStyles,
  customColors?: string[],
) => {
  return series.map((seriesItem, index) => ({
    ...seriesItem,
    showSymbol: baseStyles.seriesDefaults.showSymbol,
    symbol: baseStyles.seriesDefaults.symbol,
    symbolSize: baseStyles.seriesDefaults.symbolSize,
    smooth: baseStyles.seriesDefaults.smooth,
    smoothMonotone: baseStyles.seriesDefaults.smoothMonotone,
    lineStyle: {
      ...baseStyles.seriesDefaults.lineStyle,
      shadowColor:
        customColors?.[index] || seriesItem.itemStyle?.color || '#409EFF',
    },
    emphasis: {
      focus: 'series',
      itemStyle: {
        color: seriesItem.itemStyle?.color,
        symbolSize: 0,
      },
    },
  }))
}
